/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Instant Search Plus collection page & search autocomplete tweaks.
  // Fast Simon's code snippet was first setup in theme.liquid as {% render 'FSHooks' %}
  // and it's been moved here to keep custom JS together.
  function getProductElements(element) {
    return [...element.querySelectorAll(`.fs-results-product-card`)];
  }

  function hooks() {
    window.SerpOptions.registerHook(
      "serp-product-grid",
      ({ products, element }) => {
        for (const productElement of getProductElements(element)) {
          const productID = productElement.dataset.productId;

          /* get title */
          let titleelement = productElement.querySelector(".fs-product-title");

          // Get the text content of the element
          var originalText = titleelement.textContent;

          // Find the index of the '-' character
          var index = originalText.indexOf("-");

          // Extract the substring after '-'
          var modifiedText = originalText.slice(index + 1).trim();

          // Update the text content of the element
          titleelement.textContent = modifiedText;

          //change review style
          if (
            productElement.querySelector(".fs-reviews-count") &&
            !productElement
              .querySelector(".fs-reviews-count")
              .innerHTML.includes("reviews")
          ) {
            productElement.querySelector(".fs-reviews-count").innerHTML =
              productElement
                .querySelector(".fs-reviews-count")
                .innerHTML.replace("(", "");
            productElement.querySelector(".fs-reviews-count").innerHTML =
              productElement
                .querySelector(".fs-reviews-count")
                .innerHTML.replace(")", "");
            productElement.querySelector(".fs-reviews-count").innerHTML =
              productElement.querySelector(".fs-reviews-count").innerHTML +
              " reviews";
          }
        }
      }
    );
  }

  function AChooks() {
    FastAutocomplete.registerHook(
      "render-autocomplete-product-item",
      ({ product, index, element }) => {
        //Set up special prices
        let productID = product.id;
        let elementID = element.getAttribute("data-id");

        // get title
        let titleelement = element.querySelector(".fs-product-title");

        if (product.l) {
          // Find the index of the '-' character
          var index = product.l.indexOf("-");

          // Extract the substring after '-'
          var modifiedText = product.l.slice(index + 1).trim();

          // Update the text content of the element
          if (
            titleelement ||
            !titleelement.classList.contains("isp-cstm-price-" + productID)
          ) {
            titleelement.textContent = modifiedText;
            titleelement.classList.add("isp-cstm-price-" + productID);
          }
        }
      }
    );
  }

  if (window.SerpOptions) {
    hooks();
  } else {
    window.addEventListener("fast-serp-ready", function () {
      hooks();
    });
  }

  if (window.FastAutocomplete) {
    AChooks();
  } else {
    window.addEventListener("fast-autocomplete-ready", function () {
      AChooks();
    });
  }

  // Momentjs used to show and hide phone number between 8am and 4pm - Michael 9-5-2019
  // Resource: https://momentjs.com/docs/#/get-set/hour/
  var momentHour = moment().hour();
  var momentMinute = moment().minute();
  var momentDay = moment().weekday();

  // momentMinute counts up from 0 to 59, this pre-pends a 0 if it's less than 9 minutes - Michael 2-7-2020
  if (momentMinute <= 9) {
    momentMinute = "0" + momentMinute;
  }

  var momentTime = momentHour + "" + momentMinute;

  // console.log ("Hours: " + momentHour);
  // console.log ("Minutes: " + momentMinute);
  // console.log("Current Time: " + momentTime);

  if (
    momentTime >= 830 &&
    momentTime <= 1630 &&
    momentDay >= 1 &&
    momentDay <= 5
  ) {
    // $('.momentjs-phone').show();
    // Do nothing
  } else {
    // $('.momentjs-phone').hide();
    //$(".phone-wrapper").addClass("momentjs-phone");
    phoneWrapper();
  }

  function phoneWrapper() {
    var element = document.getElementById("phone-wrapper");
    element.classList.add("momentjs-phone");
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
